import { render, staticRenderFns } from "./GCCReceived.vue?vue&type=template&id=65ee1e1e&"
import script from "./GCCReceived.vue?vue&type=script&lang=js&"
export * from "./GCCReceived.vue?vue&type=script&lang=js&"
import style0 from "./GCCReceived.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports